.slider {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  touch-action: none;
}

.sliderLabel {
  display: flex;
  align-self: stretch;
}

.label,
div[style='isolation: isolate; color-scheme: light;'] .label  {
  color: #707070;
}

.value,
div[style='isolation: isolate; color-scheme: light;'] .value {
  color: #585858;
  margin-left: auto;
}

div[style='isolation: isolate; color-scheme: dark;'] .label {
  color: #b0b0b0;
}

div[style='isolation: isolate; color-scheme: dark;'] .value {
  color: #9a9a9a;
}

@media screen and (prefers-color-scheme: light) {
  div[style='isolation: isolate; color-scheme: light dark;'] .label {
    color: #707070;
  }
  
  div[style='isolation: isolate; color-scheme: light dark;'] .value {
    color: #585858;
  }
}

@media screen and (prefers-color-scheme: dark) {
  div[style='isolation: isolate; color-scheme: light dark;'] .label {
    color: #b0b0b0;
  }
  
  div[style='isolation: isolate; color-scheme: light dark;'] .value {
    color: #9a9a9a;
  }
}

.thumb {
  position: absolute;
  top: 4px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.thumbHandle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #707070;
  box-sizing: border-box;
  background-color: #f5f5f5;
  box-shadow: 0 0 0 4px #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.thumbHandle label {
  color: #707070;
}

.thumbFocusVisible .thumbHandle {
  box-shadow: 0 0 0 2px #f5f5f5, 0 0 0 4px #2c83eb;
}

.thumbFocused {
  border-color: #2c83eb;
  z-index: 1;
}

.thumbDisabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.thumbDisabled label {
  cursor: inherit;
}

.rail {
  position: absolute;
  background-color: #e4e4e4;
  height: 3px;
  top: 13px;
  width: 100%;
}

.filledRail {
  position: absolute;
  height: 3px;
  background-color: #707070;
  top: 13px;
  height: 3px;
  top: 13px;
  left: 0;
}

.track {
  position: relative;
  height: 30px;
  width: 100%;
}

.trackContainer {
  position: relative;
  width: 100%;
}

.tip {
  margin-top: 8px;
}
